module.exports = __webpack_public_path__ + "static/img/payment-mir.7d38e807.svg";